import { LabelValueLower } from 'src/app/models/keyvalue';
import { GridFilterItemFinal, IFacetQueryItem } from 'src/app/shared/grid/grid.model';
import { ISmartActionContext } from '../../../models/smart-actions.models';
import { GridDataResult, GridFilterItem } from '../../../shared/grid/grid.model';


export interface ISearchConfig {
    itemSmartActionFunc?: (item: IMemberListItemContext) => ISmartActionContext;
}

export interface IMemberSearchComponentConfig extends ISearchConfig {
    hideAddMember?: boolean;
    hideHeader?: boolean;
    zIndex?: number;
    scrollHeight?: string;
    excludePreviousSearch?: boolean;
}

export const Genders: LabelValueLower[] = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Unknown', value: 'unknown' }
];

export interface IMemberListItem {
    CombinedId: string;
    Id: number;
    ExternalId: string;
    FirstName: string;
    MI: string;
    MBI: string;
    PBP: string;
    LastName: string;
    CardNumber: string;
    ContractNumber: string;
    SourceType: string;
    MemberType: string;
    DateOfBirth: string;
    EmailAddress: string;
    TenantName: string;
    Addresses: IMemberListItemAddress[];
    Phones: IMemberListItemPhone[];
}


export interface IMemberListItemAddress {
    Street1: string;
    Street2: string;
    City: string;
    State: string;
    PostalCode: string;
    County: string;
}

export interface IMemberListItemPhone {
    Number: string;
}










/**********************************New Member Metadata ****************************************************************** */
/************ Request**************/
export interface IMemberSearchMetadataRequest {

    criteria: string;
    skillName: string;
    contactId: string;
    direction: string;
    tenantId: string;
}


/************ Request Result**************/
export interface IMemberSearchMetadataResponse {
    criteria: string;
    filters: IMemberSearchMetadataResponseFilter[];
}



/**********************************New Member Search  ****************************************************************** */
/************ Request**************/

export interface IMemberSearchRequest {
    tenants: any;
    first: number;
    rows: number;
    sort: any[];
    criteria?: string;
    columnFilters?: GridFilterItemFinal[];
    facets: IFacetQueryItem[];
}


export interface IMemberSearchState {
    tenants: any;
    criteria?: string;
    columnFilters?: GridFilterItem[];
}

export interface IMemberSearchRequestSortItem {
    fieldName: string;
    direction: MemberSearchRequestDirectionEnum;
}

export enum MemberSearchRequestDirectionEnum {
    desc = -1,
    asc = 1
}

/************ Request Result**************/
export interface IMemberSearchResponse {
    count: number;
    facets: IMemberSearchResponseFacetResult[];
    results: IMemberSearchResponseTenantSearchResult[];
    tenantSourceMapping?: { [key: string]: string[] };
    searchFilterColumnDefinitions?: IMemberSearchMetadataResponseFilter[];
}

export class MemberSearchResponseFormatted extends GridDataResult<IMemberListItemContext> {
    items: IMemberListItemContext[];
    filteredCount = 0;
    currentPageSize = 0;

    constructor(input?: Partial<MemberSearchResponseFormatted>) {
        super();
        Object.assign(this, input);
        this.items = this.items || [];
    }

    getItems(): IMemberListItemContext[] {
        return this.items;
    }
}

export interface IMemberListItemContext {
    item: IMemberListItemNew;
    repoMetadata: IMemberListItemContextRepoMetadata;
    name: string;
    color: string;
    smartActions: ISmartActionContext;
}

export interface IMemberListItemContextRepoMetadata {
    repository: string;
    // actions: IMemberSearchResponseRepositoryConfigurationSearchAction[];
    tenantId: string;
}

export interface SearchColumnFilter {

}

export interface IMemberSearchResponseTenantSearchResult {
    name: string;
    tenantId: string;
    tenantDisplayName: string;
    result: any[];
    color: string;
    facets: { [key: string]: IMemberSearchResponseFacetResult[] };
    actions: IMemberSearchResponseRepositoryConfigurationSearchAction[];
    count: number;
}

export interface IMemberSearchResponseRepositoryConfigurationSearchAction {
    DisplayName: string;
    Icon: string;
    Metadata: any;
    Type: string;
    UIComponent: string;
}

export interface IMemberSearchResponseCombineFacetSearchResult {
    name: string;
    values: IMemberSearchResponseFacetResult[];
}

export interface IMemberSearchResponseFacetResult {
    name: string;
    values: {
        value: string;
        count: number
    }[];
    count: number;
}


export interface IMemberSearchMetadataResponseFilter {
    property: string;
    isFacetable: boolean;
    values?: IMemberSearchMetadataResponseFilterValue[];
    mappings?: IMemberSearchMetadataRepositoryMapping[];
}

export interface IMemberSearchMetadataResponseFilterValue {
    name?: string;
    isSelected?: boolean;
    count?: number;
}

export interface IMemberSearchMetadataRepositoryMapping {
    tenantId: string;
    repositories: IMemberSearchMetadataResponseFilterValue[];
}



export interface IFacet {
    value: string;
    count: number;
}

export interface IMemberListItemNew {
    "@search.score": number;
    Id: string;
    IdBase64: string;
    CardNumber: string;
    MBI: string;
    ContractNumber: string;
    PBP: string;
    FirstName: string;
    MiddleInitial: string;
    LastName: string;
    DateOfBirth: string;
    EmailAddress: string;
    Addresses: IMemberListItemAddress[];
    Phones: IMemberListItemPhone[];
    smartActions: ISmartActionContext;
    TenantId: string;

    ResultColor?: string;
    Actions: IMemberSearchResponseRepositoryConfigurationSearchAction[];
}

export interface MemberActionConfig {
    selectedAction: IMemberSearchResponseRepositoryConfigurationSearchAction;
    item: IMemberListItemContext;
}


export enum MemberActionsEnum {
    OPEN = 'OPEN',
    CONVERT = 'CONVERT',
    CONVERTMEMBERURL = 'CONVERTMEMBERURL',
    UICOMPONENT = 'UICOMPONENT'
    // SUSPEND = 'SUSPEND'
}

